
/**
 * @file Signup action types
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

export const UPDATE_ERROR = "UPDATE_ERROR";

export const CHANGE_USERNAME = "CHANGE_USERNAME";
export const CHANGE_EMAIL = "CHANGE_EMAIL";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_SRC = "CHANGE_SRC";
export const CHANGE_PLAN_FEE = "CHANGE_PLAN_FEE";
export const CHANGE_PLAN_CODE = "CHANGE_PLAN_CODE";
export const CHANGE_PROMO = "CHANGE_PROMO";
export const VALIDATE_USERNAME = "VALIDATE_USERNAME";
export const VALIDATE_EMAIL = "VALIDATE_EMAIL";
export const VALIDATE_PASSWORD = "VALIDATE_PASSWORD";
export const VALIDATE_FORM = "VALIDATE_FORM";

export const REQUEST_FORM_SUBMIT_STARTED = "REQUEST_FORM_SUBMIT_STARTED";

export const REQUEST_USERNAME_AVAILABLE_STARTED = "REQUEST_USERNAME_AVAILABLE_STARTED";
export const REQUEST_USERNAME_AVAILABLE_SUCCEED = "REQUEST_USERNAME_AVAILABLE_SUCCEED";
export const REQUEST_USERNAME_AVAILABLE_FAILED = "REQUEST_USERNAME_AVAILABLE_FAILED";
export const REQUEST_USERNAME_IS_A_EMAIL_FAILED = "REQUEST_USERNAME_IS_A_EMAIL_FAILED";

export const REQUEST_EMAIL_AVAILABLE_STARTED = "REQUEST_EMAIL_AVAILABLE_STARTED";
export const REQUEST_EMAIL_AVAILABLE_SUCCEED = "REQUEST_EMAIL_AVAILABLE_SUCCEED";
export const REQUEST_EMAIL_AVAILABLE_FAILED = "REQUEST_EMAIL_AVAILABLE_FAILED";

export const SET_REFERRAL_CODE = "SET_REFERRAL_CODE";